export const arProductName = 'Arbeitsrecht für Betriebsräte'
